import ChapterList from './ChapterList';
import '../css/mictlan.css';
import '../css/chapters.css';

export default function Capitulos() {
  return (
    <div className='mictlan-bg'>
      <div className="container mt-5 mainMargin">
        <ChapterList />
      </div>

      <div className="bg_landscape"></div>
      <div className="reflection"></div>
    </div>
  );
}